import i18n from '@/languages/i18n';
import { FreightDeliveryOrderLine } from './freight';
import { PriceType } from './pricemanager';
import { OrderProductlistRow } from '@/types/Productlist';

export function getOrderPriceReasons(): {
  value: string;
  label: string;
  translation?: string;
}[] {
  return [
    { value: '', label: '---' },
    { value: 'GOD', label: 'GOD', translation: i18n.global.t('price.reason_for_action.GOD') },
    { value: 'NOR', label: 'NOR', translation: i18n.global.t('price.reason_for_action.NOR') },
    { value: 'OBJ', label: 'OBJ', translation: i18n.global.t('price.reason_for_action.OBJ') },
    { value: 'REK', label: 'REK', translation: i18n.global.t('price.reason_for_action.REK') },
    { value: 'RET', label: 'RET', translation: i18n.global.t('price.reason_for_action.RET') },
    { value: 'SAM', label: 'SAM', translation: i18n.global.t('price.reason_for_action.SAM') },
  ];
}

export enum RowRetentionStrategy {
  Discounts = 'discounts',
  Price = 'price',
}

export function getRowRetentionStrategy(
  row: FreightDeliveryOrderLine | OrderProductlistRow
): RowRetentionStrategy | null {
  if (!row.actionReason) return null;

  // BEN-2100: Retain discounts if set, fallback to retaining price
  let retainDiscounts = false;
  for (let index = 1; index <= 6; index++) {
    const discount = row.price_manager?.getDiscount(PriceType.Line, index as 1 | 2 | 3 | 4 | 5 | 6) as
      { discount: string; text: string; status: string } | undefined;
    if (discount?.discount != '0') {
      retainDiscounts = true;
      break;
    }
  }

  if (retainDiscounts) {
    return RowRetentionStrategy.Discounts;
  }
  return RowRetentionStrategy.Price;
}
